import SessionManager from '@/Manager/Session.manager'
import KeyboardManager from '@/Manager/keyboard.manager'
import {
    serverBus
} from '@/main'

import Global from '@/scripts/Global'
import {
    CPUtils
} from '@/scripts/Utils'
import ChannelApi from '@/scripts//api/channel.api'
import UserApi from '@/scripts//api/user.api'
import VueSignals from '@/scripts/VueSignals'

export default {
    data: function() {
        return {
            data: "",
            user_star: false,
            hover_star: false,
            right_sidebar_collapsed: SessionManager.getLoggedInUser().chat_visuals.sidebar_collapsed,
            right_sidebar_collapsed_mobile: true,
            active_channel_doc: SessionManager.getActiveChannel(),
            subfolder: false,
            parent_docs: [],
            inCall: false,
            isCallInitUser: true,
            allUsers: CPUtils.RemoveLoggedInUser(SessionManager.getUsers()),
            filterdUsers: CPUtils.RemoveLoggedInUser(SessionManager.getUsers()),
            filter_user_list: '',
            channelUsers: [],
            selectedUsers: [],
            showInvite: false,
            loggedInUserId: SessionManager.getLoggedInUserId(),
            showLeftSidebarMobileFlag: false,
            isPossibleToCall: true,
        }
    },
    props: {
        isSearch: Boolean,
        ChannelUsersCount: Number,
        purpose: String,

    },
    computed: {
        isAllowedCalls() {
            return Global.isELectron() || Global.isDevelop() || Global.isTest()
        }
    },
    updated() {
        if (this.inCall) {
            Global.globalValue("SHOW_CONFERENCE", true)
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_COLLAPSED, false)
            Global.globalValue(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE, true)
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_THEME, 'conference')
        }
    },
    mounted() {
        // serverBus.$on(VueSignals.SEARCH_FEED_TEXT, (value) => {
        //     document.getElementById("chat-search").value = value
        // })

        serverBus.$on(VueSignals.RIGHT_SIDEBAR_COLLAPSED, (value) => {
            this.right_sidebar_collapsed = value
        })

        serverBus.$on(VueSignals.TOOGLE_RIGHT_SIDE_BAR, (value) => {
            if (this.right_sidebar_collapsed_mobile) {
                this.showRightSidebarMobile();
            } else {
                this.hideRightSidebarMobile();
            }
        });


        if (!this.isSearch) {
            /********************Get Current loggedin User Visual****************/
            serverBus.$on(VueSignals.LOGGED_IN_USER, (success) => {
                this.right_sidebar_collapsed = SessionManager.getLoggedInUser().chat_visuals.sidebar_collapsed
                this.user_cp_id = SessionManager.getLoggedInUser().user_id
            })
        }

        serverBus.$on(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL_NAME, (success) => {
            this.active_channel_doc = SessionManager.getActiveChannel()
            if (typeof this.active_channel_doc.channel_name != 'undefined' &&
                this.active_channel_doc.channel_name.length > 20) {
                this.active_channel_doc.channel_name = this.active_channel_doc.channel_name.substring(0, 20)
            }
        })

        serverBus.$on(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL, (success) => {
            if (typeof this.active_channel_doc.channel_name != 'undefined' &&
                this.active_channel_doc.channel_name.length > 20) {
                this.active_channel_doc.channel_name = this.active_channel_doc.channel_name.substring(0, 20)
            }
            this.right_sidebar_collapsed_mobile = true // for mobile
            this.active_channel_doc = SessionManager.getActiveChannel()
            this.user_star = this.active_channel_doc.loggedinStar
            this.hover_star = this.active_channel_doc.loggedinStar
            this.subfolder = false
            this.parent_docs = []
            this.showInvite = false
            this.selectedUsers = this.active_channel_doc.user_ids
            this.allUsers = CPUtils.RemoveLoggedInUser(SessionManager.getUsers())
            this.filterdUsers = CPUtils.RemoveLoggedInUser(SessionManager.GetActiveChannelUsers())
            this.isPossibleToCall = true
            if (this.active_channel_doc.direct) {
                this.isCloudBot = this.active_channel_doc.channel_name == 'CloudBot'
                this.isFeedback = this.active_channel_doc.channel_name == 'Feedback'
                this.isPossibleToCall = !(this.active_channel_doc.user_ids[0] == this.active_channel_doc.user_ids[1])

                if (this.isCloudBot || this.isFeedback) {
                    this.isPossibleToCall = false
                }
            }
        })

        serverBus.$on(VueSignals.ACTIVE_POSSIBLE_CHANGED, (success) => {
            this.right_sidebar_collapsed_mobile = true // for mobile
            this.subfolder = false
            this.parent_docs = []
        })

        serverBus.$on(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE, (status) => {
            if (!status) {
                this.right_sidebar_collapsed_mobile = true
            }
        })

        serverBus.$on(VueSignals.ACTIVE_CHANNEL_PARENT_DOCS, (parent_docs) => {
            if (parent_docs.length > 0) {
                this.subfolder = true
                this.parent_docs = parent_docs
            }
        })

        serverBus.$on("inCall", (status) => {
            this.inCall = status
            if (!this.inCall) {
                this.isCallInitUser = true
                this.selectedUsers = this.active_channel_doc.user_ids
            }
        })

        serverBus.$on("callInitUserId", (user_id) => {
            if (SessionManager.getLoggedInUser() != user_id) {
                this.isCallInitUser = false
            }
        })

        if (window.innerWidth <= 900) {
            document.querySelector('.chat-pannel').addEventListener('click', () => {
                let menuPosition = Global.getOpenMenu()
                if (menuPosition == 'left') {
                    Global.globalValue(VueSignals.SHOW_LEFT_SIDEBAR_MOBILE, false)
                }
                if (menuPosition == 'right') {
                    Global.globalValue(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE, false)
                }
            })
        }

        //@@TODO fix swapping
        // window.addEventListener('touchmove', function(e){

        //     if(e.changedTouches[0].pageX < 100){
        //       Global.globalValue(VueSignals.SHOW_LEFT_SIDEBAR_MOBILE, true)
        //       // Global.globalValue(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE, false)
        //     }else {
        //       Global.globalValue(VueSignals.SHOW_LEFT_SIDEBAR_MOBILE, false)
        //     }

        //     if(window.innerWidth - e.changedTouches[0].pageX < 100){
        //       Global.globalValue(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE, true)
        //       // Global.globalValue(VueSignals.SHOW_LEFT_SIDEBAR_MOBILE, false)
        //     }else {
        //       Global.globalValue(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE, false)
        //     }

        // if(!Global.isOpenMenu()){
        //   if(e.changedTouches[0].pageX < 70){
        //     Global.globalValue(VueSignals.SHOW_LEFT_SIDEBAR_MOBILE, true)
        //   }

        //   if(window.innerWidth - e.changedTouches[0].pageX < 70){
        //     Global.globalValue(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE, true)
        //   }
        // }
        // })

        serverBus.$on(VueSignals.SHOW_LEFT_SIDEBAR_MOBILE, (statue) => {
            this.showLeftSidebarMobileFlag = statue
        })
    },
    methods: {
        ChannelStar() {
            let active_channel = SessionManager.getActiveChannel()
            let loggedin_user = SessionManager.getLoggedInUser()
            if (this.user_star) {
                ChannelApi.removeStar(active_channel.channel_id)
                this.user_star = false
                this.hover_star = false
                active_channel.loggedinStar = false
            } else {
                ChannelApi.addStar(active_channel.channel_id)
                this.user_star = true
                this.hover_star = true
                active_channel.loggedinStar = true
            }
            SessionManager.UpdateChannel(active_channel.channel_id, {
                "loggedinStar": active_channel.loggedinStar
            })
        },
        showLeftSidebarMobile() {
            Global.globalValue(VueSignals.SHOW_LEFT_SIDEBAR_MOBILE, true)
        },
        showRightSidebar() {
            this.right_sidebar_collapsed = !this.right_sidebar_collapsed;
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_COLLAPSED, this.right_sidebar_collapsed)
            let visual = {
                "sidebar_collapsed": this.right_sidebar_collapsed
            }
            UserApi.UpdateUserVisual(visual)
        },
        showChannelUsers() {
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_COLLAPSED, false)
            Global.globalValue(VueSignals.CHANNEL_USERS_HIGHLIGHT, true)
        },
        showChannelOptions() {
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_COLLAPSED, false)
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_THEME, 'channel_settings')
            Global.globalValue(VueSignals.CHANNEL_OPTIONS_HIGHLIGHT, true)
        },
        showRightSidebarMobile() {
            Global.globalValue(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE, true)
            this.right_sidebar_collapsed_mobile = false
        },
        hideRightSidebarMobile() {
            Global.globalValue(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE, false)
            this.right_sidebar_collapsed_mobile = true
        },
        SearchON() {
            // document.addEventListener('keydown', function(e) {
            //     document.getElementById("chat-search").value = ''
            // })
            // document.getElementById("chat-search").classList += " open"
            KeyboardManager.disableChatMode()
            setTimeout(function() {
                Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
                Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, 'search')
                Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {
                    "channel_name": SessionManager.getActiveChannel().channel_name,
                    "channel_id": SessionManager.getActiveChannel().channel_id
                })
            }, 500)
        },
        Call() {
            if (!this.inCall) {
                this.showInvite = false
                Global.globalValue("RTC_Call", true)
                this.selectedUsers
                if (!this.active_channel_doc.direct && this.selectedUsers.length > 1) {
                    Global.globalValue("ScreenCall", this.selectedUsers)
                } else if (this.active_channel_doc.direct) {
                    Global.globalValue("ScreenCall", this.selectedUsers)
                } else {
                    Global.globalValue("rtc_call_banner_message_red", "Not allowed to have a call in non direct channel with one user")
                }
                this.inCall = true
            } else {
                this.CallInvite()
            }
        },
        ShowInvite() {
            if (this.inCall) {
                this.selectedUsers = []
            }
            this.showInvite = !this.showInvite
        },
        SelectUser(user_id) {
            if (this.selectedUsers.indexOf(user_id) > -1) {
                this.selectedUsers.splice(this.selectedUsers.indexOf(user_id), 1)
            } else {
                this.selectedUsers.push(user_id)
            }

        },
        FilterUsers() {
            KeyboardManager.disableChatMode()
            this.filterdUsers = this.allUsers.filter(currUser => {
                return currUser.username.toLowerCase().indexOf(this.filter_user_list.toLowerCase()) > -1 || currUser.email.toLowerCase().indexOf(this.filter_user_list.toLowerCase()) > -1
            })
        },
        GetUser(user_id) {
            return SessionManager.getUser(user_id)
        },
        CallInvite() {
            Global.globalValue("invite_rtc_call", this.selectedUsers)
            this.showInvite = false
        },
        selectAll(all) {
            if (all) {
                this.selectedUsers = this.active_channel_doc.user_ids
            } else {
                this.selectedUsers = []
            }
        },
        selectOnline() {
            this.selectedUsers = []
            for (let i = 0; i < this.allUsers.length; i++) {
                if (this.active_channel_doc.user_ids.indexOf(this.allUsers[i].user_id) > -1 &&
                    this.allUsers[i].status_mode == "online") {
                    this.selectedUsers.push(this.allUsers[i].user_id)
                }
            }
        },
        hasURL(message) {
            return CPUtils.hasURL(message)
        },
        getBeforeText(text) {
            let returnText = ''
            if (CPUtils.getURL(text).length > 0) {
                returnText += text.slice(0, text.indexOf(CPUtils.getURL(text)))
                text = text.slice(0, text.indexOf(CPUtils.getURL(text)))
            }
            return returnText
        },
        getRestText(text) {
            let returnText = ''
            let URL = CPUtils.getURL(text);
            if (URL.length > 0) {
                returnText += text.slice(text.indexOf(URL) + URL.length)
            }
            return returnText
        },
        DisplayWithURL(pargraph) {
            let itemBeforeURL, itemAfterURL
            let structuredURLMessage = []
            let computingText = pargraph
            // Multiples link can occurs in one parragraph
            while (this.hasURL(computingText)) {
                    itemBeforeURL = this.getBeforeText(computingText)
                    structuredURLMessage.push({
                        "type": "text",
                        "value": itemBeforeURL
                    })
                    computingText = computingText.substring(itemBeforeURL.length)
                    let URL = CPUtils.getURL(computingText)
                    structuredURLMessage.push({
                        "type": "URL",
                        "value": URL
                    })
                    computingText = this.getRestText(computingText)
            }
            // Rest of the message without link
            if (computingText) {
                structuredURLMessage.push({
                    'type': 'text',
                    'value': computingText
                })
            }
            return structuredURLMessage
        }
    }
}
